import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import {
  KuspitEarningsReportHttpRepository,
} from './infrastructure/repository';

// Application
import { SearchKuspitEarningsReportQuery } from './application/queries';

// Domain
import { KuspitEarningsReportRepository } from './domain/repository';

export default function setupKuspitEarningsReport(container: Container) {
  container
    .bind<KuspitEarningsReportRepository>(TYPES.KUSPIT_EARNINGS_REPORT_REPOSITORY)
    .to(KuspitEarningsReportHttpRepository)
    .inSingletonScope();

  container
    .bind<SearchKuspitEarningsReportQuery>(TYPES.SEARCH_KUSPIT_EARNINGS_REPORT_QUERY)
    .to(SearchKuspitEarningsReportQuery)
    .inSingletonScope();
}
